<template>
  <div
    v-if="this.init && this.session"
    ref="printMe"
    class="container mx-auto flex flex-col"
  >
    <div
      v-if="inSelectionMode || inMasterSelectionMode"
      id="overlay"
      class="flex half-black"
    >
      <div
        v-if="inSelectionMode"
        class="container mx-auto h-full overflow-y-scroll  mt-8 flex flex-col app-content-back"
      >
        <div class="flex flex-col">
          <div class="section-title flex flex-row ">
            <div class="flex-grow">
              Auswahl {{ selectionTitle }}
            </div>
            <div>
              <i
                class="far fa-window-close fa-2x cursor-pointer"
                @click="inSelectionMode=false"
              />
            </div>
          </div>
        </div>
        <sc-search
          :show-open-button="true"
          :show-add-button="true"
          :selected-youth="team.youth"
          @exerciseSelected="onOverlaySelection"
        />
      </div>

      <div
        v-if="inMasterSelectionMode"
        class="container mx-auto h-full overflow-y-scroll  mt-8 flex flex-col app-content-back"
      >
        <div class="flex flex-col">
          <div class="section-title flex flex-row ">
            <div class="flex-grow">
              Mastery Auswahl
            </div>
            <div>
              <i
                class="far fa-window-close fa-2x cursor-pointer"
                @click="inMasterSelectionMode=false"
              />
            </div>
          </div>
        </div>

        <sc-mastery-search
          :show-add-button="true"
          @itemSelected="addMastery"
        />
      </div>
    </div>

    <div class="flex flex-row mt-4">
      <div class="ctl-edit-container">
        <input
          v-model="session.title"
          class="ctl-edit"
          type="text"
          @keypress="onTitleChanged"
        >
        <button data-html2canvas-ignore
          v-show="showTitleSave"
          class="save-button  hover:bg-primary-700 hover:border-primary-700"
          type="button"
          @click="saveTitle"
        >
          Speichern
        </button>
        <button
          v-show="showTitleSave" data-html2canvas-ignore
          class="flex-shrink-0 border-transparent border-4 text-primary-500 hover:text-primary-800 text-sm py-1 px-2 rounded"
          type="button"
          @click="cancelEdits"
        >
          Abbrechen
        </button>
      </div>

      <div class="ctl-edit-container">
        <sc-date-pick
          v-model="session.date"
          :monday-first="true"
          :language="de"
          @input="inDateSelect=true"
        />
        <button
          v-show="inDateSelect"
          class="save-button  hover:bg-primary-700 hover:border-primary-700"
          type="button"
          @click="saveDate"
        >
          Speichern
        </button>
        <button
          v-show="inDateSelect"
          class="flex-shrink-0 border-transparent border-4 text-primary-500 hover:text-primary-800 text-sm py-1 px-2 rounded"
          type="button"
          @click="cancelEdits"
        >
          Abbrechen
        </button>
      </div>

      <router-link :to="{name: 'teams.detail', params: { id: this.session.teamId} }" data-html2canvas-ignore>
        <h1 class="ml-4 ">
          <i class="fas fa-users mr-1" /> {{ this.session.teamName }}
        </h1>
      </router-link>
      <router-link data-html2canvas-ignore
        :to="{name:'training.sessions.presence',params:{id:this.id}}"
        class="ml-4"
      >
        <span data-html2canvas-ignore><i class="far fa-list-alt mr-2" />Anwesenheit</span> <span
          class="ml-1 text-xs rounded-lg bg-green-500 p-1 text-white"
        >{{ session.playerReviews.length }}</span>
      </router-link>

      <span class="cursor-hand ml-4" data-html2canvas-ignore
        @click="print"      >
        <i class="fa fa-download cursor-hand"></i> Download
      </span>
    </div>

    <div class="flex flex-col mt-3">
      <div
        class="section-title mt-4 flex-grow cursor-pointer"
        @click="onDescChanged()"
      >
        <h3>Anmerkungen</h3>
      </div>
      <div class="flex-row">
        <span
          v-if="!showDescSave"
          class="cursor-pointer"
          @click="onDescChanged()"
          v-html="session.description"
        />
        <sc-html-editor
          v-if="showDescSave"
          v-model="session.description"
        />

        <button
          v-show="showDescSave"
          class="save-button  hover:bg-primary-700 hover:border-primary-700"
          type="button"
          @click="saveDesc"
        >
          Speichern
        </button>
        <button
          v-show="showDescSave"
          class="flex-shrink-0 border-transparent border-4 text-primary-500 hover:text-primary-800 text-sm py-1 px-2 rounded"
          type="button"
          @click="cancelEdits"
        >
          Abbrechen
        </button>
      </div>
    </div>

    <div
      v-if="session"
      class="flex flex-col mt-3"
    >
      <div class="section-title mt-4 flex-grow">
        <h3>Übungen</h3>
      </div>

      <h2 class="heading">
        Erwärmung / Ballgewöhnung <a data-html2canvas-ignore
          href="#"
          class="text-blue-600 text-sm ml-4"
          @click="showSelection('warmup')"
        >Hinzufügen</a>
      </h2>

      <div class="flex flex-col bg-gray-300 mb-4">
        <div class="flex flex-wrap pl-4">
          <draggable
            class="flex flex-wrap"
            :list="session.warmups"
            @end="warmupsMoved"
          >
            <sc-exercise-small
              v-for="item in session.warmups"
              :key="item.shortKey"
              :title="item.name"
              :image="item.previewAsset "
              :short-key="item.shortKey"
              :tags="item.tags"
              :show-remove-button="true"
              :show-open-button="true"
              :prefered-preview-media="item.preferedPreviewMedia"
              @removed="removeWarmupExercise"
            />
          </draggable>
        </div>
      </div>

      <h2 class="heading">
        Ballmasteries <a data-html2canvas-ignore
          href="#"
          class="text-blue-600 text-sm ml-4"
          @click="showMasterySelection()"
        >Hinzufügen</a>
      </h2>

      <div class="flex flex-col  bg-gray-300  mb-4">
        <div class="flex flex-wrap pl-4">
          <sc-mastery-small
            v-for="item in session.masteries"
            :id="item.id"
            :key="item.id"
            :title="item.name"
            :links="item.links"
            :show-add-button="false"
            :show-remove-button="true"
            @removeItem="removeMastery"
          />
        </div>
      </div>

      <div class="mt-1 mb-1 flex flex-row mt-3">
        <h2 class="heading flex-grow">
          Hauptteil <a data-html2canvas-ignore
            v-if="!inSelectionMode"
            href="#"
            class="text-blue-600 text-sm ml-4"
            @click="showSelection('main')"
          >Hinzufügen</a>
        </h2>
        <span data-html2canvas-ignore class="text-xs">Schwerpunkt der Übungen  </span>
        <span data-html2canvas-ignore
          data-balloon="Aus den Tags der Übungen ermittelt"
          class="ml-2"
        ><i
          class=" ext-xs far fa-question-circle cursor-pointer"
        /></span>
        <div class="ml-4">
          <span
            v-for="name in session.emphasisTags"
            :key="name"
            class="tag flex-grow"
          >{{ name }}</span>
        </div>
      </div>

      <div class="flex bg-gray-300 flex-col">
        <div class="flex flex-wrap pl-4">
          <draggable
            class="flex flex-wrap"
            :list="session.exercises"
            @end="exerciseMoved"
          >
            <sc-exercise-small
              v-for="item in session.exercises"
              :key="item.shortKey"
              :title="item.name"
              :image="item.previewAsset"
              :short-key="item.shortKey"
              :tags="item.tags"
              :intensity="item.intensity"
              :difficulty="item.difficulty"
              :show-remove-button="true"
              :show-open-button="true"
              :prefered-preview-media="item.preferedPreviewMedia"
              @removed="removeExercise"
            />
          </draggable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { de } from 'vuejs-datepicker/dist/locale'
import apiService from '../api/apiService'
import draggable from 'vuedraggable'
import html2canvas from 'html2canvas'
import download from 'downloadjs'

export default {
    name: 'TrainingModify',

    components: { draggable },
    data () {
        return {
            init: false,
            de: de,
            showTitleSave: false,
            showDescSave: false,
            id: null,
            session: null,
            inSelectionMode: false,
            warmUpInSelectionMode: false,
            selectionTitle: '',
            selectionMode: '',
            inMasterSelectionMode: false,
            inDateSelect: false,
            dragging: false,
            team: null,
            dataUrl: null

        }
    },

    computed: {
        fileName: function () {
            return this.session.title + '.png'
        },
        title: function () {
            if (!this.session) {
                return ''
            } else {
                return this.session.title
            }
        }
    },
    async mounted () {
        this.init = false
        this.id = this.$route.params.id

        if (this.id) {
            await this.load()
            this.team = (await apiService.getTeam(this.session.teamId)).data
            if (this.session.date < new Date(2016, 9, 16)) {
                this.session.date = new Date(2019, 1, 1)
            }

            await apiService.setViewed(this.id)
            this.inDateSelect = false
            this.showDescSave = false
        }

        this.init = true
    },
    methods: {
        async removeMastery (mastery) {
            await apiService.removeMasteryToSession(this.id, mastery)

            await this.load()
        },
        async print () {
            const el = this.$refs.printMe
            var canvas = await html2canvas(el, {
              ignoreElements: function (element) {
                return element.hasAttribute('data-html2canvas-ignore')
              }
            })
            this.dataUrl = canvas.toDataURL('image/png')

            download(this.dataUrl, this.fileName, 'image/png')
        },
        showSelection (type) {
            this.selectionMode = type
            if (type === 'main') {
                this.selectionTitle = 'Hauptteil'
            } else {
                this.selectionTitle = 'Erwärmen / Ballgewöhnung'
            }

            this.inSelectionMode = true
        },

        async saveDesc () {
            this.showDescSave = false
            await apiService.setDescriptionForSession(this.id, this.session.description)
        },
        async saveDate () {
            this.showDescSave = false
            await apiService.setDateForSession(this.id, this.session.date)
        },
        async saveTitle () {
            this.showTitleSave = false
            await apiService.setTitleForSession(this.id, this.session.title)
            this.inDateSelect = false
        },
        async cancelEdits () {
            this.showTitleSave = false
            this.showDescSave = false
            this.inDateSelect = false
            await this.load()
        },
        onDescChanged () {
            this.showDescSave = true
            console.log(this.session.description)
        },
        onTitleChanged () {
            this.showTitleSave = true
        },
        async removeExercise (shortKey) {
            await apiService.removeExerciseFromSession(this.id, shortKey)
            await this.load()
        },

        async removeWarmupExercise (shortKey) {
            await apiService.removeWarmupExerciseFromSession(this.id, shortKey)
            await this.load()
        },

        async load () {
            const response = await apiService.getSsession(this.id)
            this.session = response.data
            this.session.date = new Date(this.session.date)
        },

        async onOverlaySelection (item) {
            const key = item.shortKey

            if (this.selectionMode === 'main') {
                await apiService.addExerciseToSession(this.id, key)
            } else {
                await apiService.addWarmupExerciseToSession(this.id, key)
            }
            await this.load()
            this.inSelectionMode = false
        },

        async addMastery (mastery) {
            console.log('adding mastery')
            await apiService.addMasteryToSession(this.id, mastery)
            await this.load()

            this.inMasterSelectionMode = false
            this.inSelectionMode = false
        },
        async exerciseMoved (e) {
            const ids = this.session.exercises.map(x => x.shortKey).flat()

            await apiService.setExerciseOrder(this.id, ids)
        },

        async warmupsMoved (e) {
            const ids = this.session.warmups.map(x => x.shortKey).flat()
            await apiService.setWarmupsOrder(this.id, ids)
        },

        searchForExercise () {
            this.inSelectionMode = true
        },
        showMasterySelection () {
            this.inMasterSelectionMode = true
        }
    }
}
</script>

<style scoped>

</style>
